import Storage from './Storage'

const dateOnly={day: 'numeric', month: 'numeric', year: 'numeric',}

const dateOnlyShort={hour12: false, day: 'numeric', month: 'numeric'}

const dateTimeShort={hour12: false, day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric',}

const dateTimeLong ={hour12: false, day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric',minute: 'numeric',}


const DateUtil = {

  formatDate(date, layout){

    let format = dateTimeShort;
    switch (layout){
      case 'dateOnly':
        format = dateOnly;
        break;
      case 'dateOnlyShort':
        format = dateOnlyShort;
        break;
      case 'dateTimeLong':
        format = dateTimeLong;
        break;
      default: format =  dateTimeShort;
    }


    const formatter = new Intl.DateTimeFormat('fr', format);
    if (formatter.formatToParts){
      const allowedLiteral = ['/', ':']
      const formatted = formatter.formatToParts(new Date(date)).map(({type, value}) => {
        switch (type) {
          case 'literal': return allowedLiteral.includes(value) ? value : ' ';
          default : return value;
        }
      }).reduce((string, part) => string + part)
      return formatted;
    } else {
      // IE
      const lg = Storage.getItem("lg");
      return new Intl.DateTimeFormat(`${lg}-BE`, format).format(new Date(date));

    }

  }

};

export default DateUtil;
